// src/components/home/PrimaryActions.jsx
import React from "react";
import { Car, CalendarDays, ArrowUpRight } from "lucide-react";

const PrimaryActions = ({ onBookRide, onBookAppointment }) => (
  <section className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
    <div className="grid gap-4 md:grid-cols-2">

      {/* Book Ride */}
      <button
        type="button"
        onClick={onBookRide}
        className="
          group relative overflow-hidden rounded-3xl
          bg-[#00A260] p-6 text-left text-white
          shadow-[0_15px_40px_rgba(0,162,96,0.18)]
          transition-all duration-500
          hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(0,162,96,0.28)]
          sm:p-8
        "
      >
        {/* Decorative circles */}
        <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-white/10 transition-transform duration-700 group-hover:scale-125" />
        <div className="absolute -bottom-16 -right-5 h-40 w-40 rounded-full border border-white/10" />

        <div className="relative z-10 flex items-start justify-between gap-5">
          <div>
            <div className="
              mb-5 flex h-14 w-14 items-center justify-center
              rounded-2xl bg-white/15 backdrop-blur-sm
              transition-transform duration-500 group-hover:scale-110
            ">
              <Car className="h-7 w-7" />
            </div>

            <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/70">
              NJV Tours & Travels
            </p>

            <h3 className="mt-2 text-2xl font-extrabold tracking-tight sm:text-3xl">
              Book Your Ride
            </h3>

            <p className="mt-2 max-w-sm text-sm leading-6 text-white/80">
              Cars, Ertiga, vans and coaches available for regular and emergency travel.
            </p>
          </div>

          <span className="
            flex h-11 w-11 shrink-0 items-center justify-center
            rounded-full bg-white text-[#00A260]
            transition-all duration-300
            group-hover:rotate-45
          ">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>

        <div className="relative z-10 mt-6 flex items-center gap-2 text-sm font-bold">
          <span>Reserve your vehicle</span>
          <span className="h-px w-8 bg-white/50 transition-all duration-300 group-hover:w-14" />
        </div>
      </button>

      {/* Book Appointment */}
      <button
        type="button"
        onClick={onBookAppointment}
        className="
          group relative overflow-hidden rounded-3xl
          bg-[#061A3A] p-6 text-left text-white
          shadow-[0_15px_40px_rgba(6,26,58,0.18)]
          transition-all duration-500
          hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(6,26,58,0.28)]
          sm:p-8
        "
      >
        {/* Decorative circles */}
        <div className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-[#F97316]/10 transition-transform duration-700 group-hover:scale-125" />
        <div className="absolute -bottom-20 right-10 h-44 w-44 rounded-full border border-[#F97316]/10" />

        <div className="relative z-10 flex items-start justify-between gap-5">
          <div>
            <div className="
              mb-5 flex h-14 w-14 items-center justify-center
              rounded-2xl bg-[#F97316]/15 text-[#F97316]
              transition-transform duration-500 group-hover:scale-110
            ">
              <CalendarDays className="h-7 w-7" />
            </div>

            <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/60">
              NJV Motors
            </p>

            <h3 className="mt-2 text-2xl font-extrabold tracking-tight sm:text-3xl">
              Book Appointment
            </h3>

            <p className="mt-2 max-w-sm text-sm leading-6 text-white/70">
              Buy, sell, exchange or get professional vehicle consultancy.
            </p>
          </div>

          <span className="
            flex h-11 w-11 shrink-0 items-center justify-center
            rounded-full bg-[#F97316] text-white
            transition-all duration-300
            group-hover:rotate-45
          ">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </div>

        <div className="relative z-10 mt-6 flex items-center gap-2 text-sm font-bold text-white">
          <span>Schedule with NJV Motors</span>
          <span className="h-px w-8 bg-[#F97316]/60 transition-all duration-300 group-hover:w-14" />
        </div>
      </button>

    </div>
  </section>
);

export default PrimaryActions;